import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { ClinicContext } from "../../Context/ClinicContext";
import css from "./TerAct.module.css";
import { Head } from "../../Utils/Head";
import { updateUserFirebase } from "../../Utils/firebaseUser";
import { UserContext } from "../../Context/UserContext";

export const JourneyIntroduction = () => {
  const { userData, setUserData } = useContext(UserContext);
  const { step, setStep } = useContext(ClinicContext);
  const navigate = useNavigate();
  const stepLength = 6;

  const finish = () => {
    const updatedJourney = {
      level: 0,
      lesson: 1,
    };

    userData.journey = updatedJourney;
    setUserData(userData);
    updateUserFirebase(userData);
    setStep(0);
    navigate("/");
  };

  return (
    <div className={css.container}>
      <Head
        title="JourneyIntroduction"
        description={"SufferingAxis - Mairini"}
      />
      <section className={css.gridTop}>
        <i
          className={`material-icons ${css.topbarIcon}`}
          onClick={() => {
            setStep(0);
            navigate("/");
          }}
        >
          close
        </i>
        <div className={css.traitBar}>
          <div
            className={css.traitScore}
            style={{
              marginRight: `${((stepLength - step) * 100) / stepLength}%`,
            }}
          ></div>
        </div>
      </section>
      <section className={css.gridMain}>
        {step === 0 && (
          <div className={css.gridMainContainer}>
            <h1>Seja bem-vindo(a) à sua jornada de autoconhecimento.</h1>
            <p>
              Aqui, vamos explorar aspectos essenciais da sua experiência humana
              — como você sente, pensa, age e escolhe.
            </p>
          </div>
        )}
        {step === 1 && (
          <div className={css.gridMainContainer}>
            <h1>
              Essa jornada foi pensada para te ajudar a responder, com
              profundidade:
            </h1>
            <p>Quem sou eu, além do que penso ou sinto?</p>
            <p>O que realmente importa para mim?</p>
            <p>Como posso lidar melhor com o sofrimento?</p>
            <p>Como posso viver com mais presença e intenção?</p>
          </div>
        )}
        {step === 2 && (
          <div className={css.gridMainContainer}>
            <h1>Durante os próximos passos, você encontrará:</h1>
            <p>
              Um
              <span> questionário de personalidade </span>para reconhecer seus
              traços predominantes.
            </p>
            <p>
              Uma
              <span> reflexão sobre valores pessoais</span>, para identificar o
              que dá sentido à sua vida.
            </p>
            <p>
              Lições sobre o<span> papel das emoções </span> e como elas guiam
              suas escolhas.
            </p>
            <p>
              Um novo olhar sobre o<span> sofrimento</span>, que o torna mais
              compreensível — e menos assustador.
            </p>
          </div>
        )}
        {step === 3 && (
          <div className={css.gridMainContainer}>
            <h1>Nosso objetivo não é encaixar você em um modelo.</h1>
            <p>
              É te oferecer ferramentas para
              <span>
                {" "}
                olhar para si mesmo com mais clareza, compaixão e direção.
              </span>
            </p>
          </div>
        )}
        {step === 4 && (
          <div className={css.gridMainContainer}>
            <h1>Essa não é uma jornada com linha de chegada.</h1>
            <p>
              Ela é um ciclo vivo, onde cada passo pode te ajudar a se sentir
              mais centrado, mais livre e mais conectado ao que importa.
            </p>
          </div>
        )}
        {step === 5 && (
          <div className={css.gridMainContainer}>
            <h1>
              Dica: não tenha pressa. Leia com atenção, explore com curiosidade,
              e escute sua própria experiência.
            </h1>
            <p>O ritmo é seu. A direção também.</p>
          </div>
        )}
        {step === 6 && (
          <div className={css.gridMainContainer}>
            <h1>Vamos começar?</h1>
            <p>
              Na próxima etapa, você responderá a algumas perguntas sobre
              <span>
                {" "}
                como você percebe o mundo, se relaciona com os outros e reage
                diante dos desafios.
              </span>
            </p>
            <p>
              Essas respostas vão nos ajudar a personalizar melhor sua jornada.
            </p>
          </div>
        )}
      </section>
      <div>
        <section className={css.gridOptions}>
          {step > 0 ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step - 1);
              }}
            >
              Anterior
            </button>
          ) : (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Anterior
            </button>
          )}
          {step === stepLength ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                finish();
              }}
            >
              Finalizar
            </button>
          ) : (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step + 1);
              }}
            >
              Próximo
            </button>
          )}
        </section>
      </div>
    </div>
  );
};
